/**
 * Extract code from markdown code blocks in question text
 */
export const extractCodeFromQuestion = (questionText: string): { code: string; language: string } => {
  // Match code blocks with optional language identifier
  const codeBlockRegex = /```(\w+)?\n?([\s\S]*?)```/;
  const match = questionText.match(codeBlockRegex);
  
  if (match) {
    const language = match[1] || 'javascript'; // Default to javascript if no language specified
    let code = match[2] || '';
    
    // Remove the first line if it exists and seems to be a language identifier
    const lines = code.split('\n');
    if (lines.length > 0 && lines[0].trim() && /^[a-zA-Z]+$/.test(lines[0].trim())) {
      code = lines.slice(1).join('\n');
    }
    
    return { code: code.trim(), language: language.toLowerCase() };
  }
  
  return { code: '', language: 'javascript' };
};

/**
 * Remove code blocks from question text for display
 */
export const removeCodeBlocksFromQuestion = (questionText: string): string => {
  return questionText.replace(/```(\w+)?\n?([\s\S]*?)```/g, '').trim();
};

